import { styled } from '@mui/material/styles';

export const Base = styled(`section`)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  gap: theme.spacing(2),
  backgroundColor: theme.palette.neutrals.beige2,
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
  marginTop: theme.spacing(3)
}));

export const Icon = styled(`div`)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '100%',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.brand.lightGreen
}));

export const Content = styled(`div`)(({ theme }) => ({}));
